import { initializeApp, getApps, type FirebaseApp } from "firebase/app";
import { firebaseConfig } from "./config";

let cachedApp: FirebaseApp | null = null;

/**
 * Returns a singleton FirebaseApp instance. Lazy so it survives
 * hot-reload in dev without re-initializing.
 */
export function getFirebaseApp(): FirebaseApp {
  if (cachedApp) return cachedApp;
  cachedApp = getApps()[0] ?? initializeApp(firebaseConfig);
  return cachedApp;
}
